import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "../../../components/CustomText";
import color from "@constants/color";

interface Line {
  title: string;
  value: Array<Record<string, string>>;
  key: string;
}

export const DeliveryIncentiveModalBody: React.FC<{
  title: string;
  lines: Array<Line>;
}> = ({ title, lines }) => {
  if (!lines?.length) return null;
  const deliveryIncentiveTableData = lines.find(
    (line) => line.key === "DELIVERED_CUSTOMERS",
  );
  return (
    <View style={styles.attendanceContainer}>
      <Text variant="title_18_regular" style={styles.modalTitle}>
        {title}
      </Text>
      <View style={styles.tableContainer}>
        <View style={styles.tableHeader}>
          <Text variant="body_text_2" style={styles.columnHeader}>
            {deliveryIncentiveTableData?.title}
          </Text>
          <Text variant="body_text_2" style={styles.columnHeader}>
            Incentive
          </Text>
        </View>
        {deliveryIncentiveTableData &&
          deliveryIncentiveTableData.value.map(({ key, value }, index) => (
            <View key={index} style={styles.tableRow}>
              <Text variant="body_text_3">{key}</Text>
              <Text variant="body_text_3">{value}</Text>
            </View>
          ))}
      </View>
    </View>
  );
};

export const AttendanceIncentiveModalBody: React.FC<{
  title: string;
  lines: Array<Line>;
}> = ({ title, lines }) => {
  if (!lines?.length) return null;

  const eligibilityData = lines.find((line) => line.key === "ELIGIBILITY");
  const presentDaysData = lines.find((line) => line.key === "PRESENT_DAYS");

  return (
    <View style={styles.attendanceContainer}>
      <Text variant="title_18_regular" style={styles.modalTitle}>
        {title}
      </Text>
      {eligibilityData && (
        <View style={styles.eligibilitySection}>
          <Text variant="body_text_2" style={styles.sectionTitle}>
            {eligibilityData.title}
          </Text>
          <View style={styles.eligibilityContent}>
            {eligibilityData.value.map(({ key, value }, index) => (
              <View key={index} style={styles.eligibilityRow}>
                <Text variant="body_text_4" style={styles.eligibilityLabel}>
                  {key}
                </Text>
                <Text variant="body_text_4" style={styles.eligibilityValue}>
                  {value}
                </Text>
              </View>
            ))}
          </View>
        </View>
      )}

      {presentDaysData && (
        <View style={styles.tableContainer}>
          <View style={styles.tableHeader}>
            <Text variant="body_text_2" style={styles.columnHeader}>
              {presentDaysData.title}
            </Text>
            <Text variant="body_text_2" style={styles.columnHeader}>
              Incentive
            </Text>
          </View>
          {presentDaysData.value.map(({ key, value }, index) => (
            <View key={index} style={styles.tableRow}>
              <Text variant="body_text_3" style={styles.cellText}>
                {key}
              </Text>
              <Text
                variant="body_text_3"
                style={[styles.cellText, styles.incentiveText]}
              >
                {value}
              </Text>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};
const styles = StyleSheet.create({
  modalTitle: {
    color: color.black,
    fontWeight: "600",
  },
  tableContainer: {
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 2,
    paddingHorizontal: 12,
    marginHorizontal: 4,
    borderRadius: 16,
    paddingVertical: 8,
  },
  tableHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  columnHeader: {
    borderBottomWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.05)",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  cellText: {
    flex: 1,
    color: color.black,
    textAlign: "left",
  },
  incentiveText: {
    textAlign: "right",
    fontWeight: "500",
  },
  attendanceContainer: {
    flex: 1,
    gap: 16,
  },
  eligibilitySection: {
    backgroundColor: "rgba(255, 235, 247, 1)",
    marginVertical: 2,
    paddingHorizontal: 12,
    marginHorizontal: 4,
    borderRadius: 16,
    paddingVertical: 8,
  },
  sectionTitle: {
    color: color.black,
    fontWeight: "600",
    marginBottom: 12,
  },
  eligibilityContent: {
    gap: 8,
  },
  eligibilityRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  eligibilityLabel: {
    color: color.black06,
    flex: 1,
  },
  eligibilityValue: {
    color: color.black,
    flex: 1,
    textAlign: "right",
  },
});
